export const ACCESS_TOKEN = "@/cq_client/auth_token"
export const USER_DATA = "@/cq_client/user"
export const REFRESH_TOKEN = "@/cq_client/refresh_token"

export const MANAGER_CLIENT_ACCESS_TOKEN = '@/cq_manager_client/auth_token'